export const countryMapping = {
    "ES": { spName: "España", name: "Spain", deName: "Spanien", emoji: "🇪🇸" },
    "CH": { spName: "Suiza", name: "Switzerland", deName: "Schweiz", emoji: "🇨🇭" },
    "US": { spName: "Estados Unidos", name: "USA", deName: "USA", emoji: "🇺🇸" },
    "CA": { spName: "Canadá", name: "Canada", deName: "Kanada", emoji: "🇨🇦" },
  };